import gql from 'graphql-tag'

export const insertNews = ({ newsData, newsRoles }) => {
	return {
		mutation: gql`
			mutation ($news: news_insert_input!) {
				insert_news_one(object: $news) {
					id
				}
			}
		`,
		variables: {
			news: {
				...newsData,
				news_roles: {
					data: newsRoles.map(rol => ({
						rol_id: rol.id
					}))
				}
			}
		}
	}
}
